<nav class="main-nav" aria-label="Primary navigation">
  <ul class="main-nav__links">
    @for (link of navLinks; track $index) {
      <li>
        <a class="strong-1 main-nav__link" [routerLink]="['/']" [fragment]="link.fragment">
          {{ link.label | translate }}
        </a>
      </li>
    }
  </ul>
  @if (!isLoggedIn()) {
    <div class="main-nav__actions">
      <button class="btn-primary main-nav__signup" [routerLink]="appRoutes.SIGN_UP">
        {{ 'headerComponent.signUp' | translate }}
      </button>
      <div class="main-nav__sign-in">
        <span>{{ 'headerComponent.or' | translate }}</span>
        <a [routerLink]="appRoutes.LOGIN" class="main-nav__sign-in-link">
          {{ 'headerComponent.signIn' | translate }}
        </a>
      </div>
    </div>
  }
</nav>
